import { handleApi } from "../utils/authentication";

export const getSubscriptionAccess = (clientId) => {
  const query = clientId ? `?client_id=${encodeURIComponent(clientId)}` : "";

  return handleApi(`subscription/access${query}`, "GET", {
    "Content-Type": "application/json",
  });
};

export const isSubscriptionBlocked = (access) =>
  !access?.can_access && access?.status !== "pending_trial";
